import axios from 'axios';

const baseDomain = process.env.VUE_APP_BACKEND_API_BASE_URL;

const httpClient = axios.create({
  baseURL: baseDomain,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

httpClient.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem('login-token');
    if (token) {
      config.headers['login-token'] = token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

export default httpClient;
